import Marionette from 'backbone.marionette';
import MentionItemview from './bill_search_mention_itemview';
import itemCompositviewTmpl from '../templates/bill_search_item_compositview.tpl';
export default Marionette.CompositeView.extend({
  template: itemCompositviewTmpl,
  childView: MentionItemview,
  childViewContainer: "#excerpts",
  initialize: function () {
    this.collection = this.model.get("mentions");
  }
});